import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
    providedIn: 'root'
})
export class CultureService {
    constructor(private _cookieService: CookieService) { }

    public setAspCulture(culture: string, domain: string) {
        let aspLocale = `c=${culture}|uic=${culture}`;
        this._cookieService.set('.AspNetCore.Culture', 
            encodeURIComponent(aspLocale),
          {
            domain: domain,
            path: '/',
            secure: true,
            sameSite: 'None',
            expires: 1
          });
    }
}